import * as React from 'react';
import { BaseComponent } from './BaseComponent';

interface InputCheckBoxProps extends React.Props<InputCheckBox> {
    onClick: () => void;
    active: boolean;
    label: string;
}

export class InputCheckBox extends BaseComponent<InputCheckBoxProps, {}> {
    public render(): JSX.Element {
        return (
            <div
                className={'input-toggle-box' + ((this.props.active) ? ' input-toggle-box-checked' : '')}
                onClick={this.props.onClick}
                tabIndex={0}
                onKeyDown={this.onKeyDown}
            >
                {this.props.label}
            </div>
        );
    }

    protected onKeyDown = (event: React.KeyboardEvent): void => {
        if (event.keyCode === 32) {
            this.props.onClick();
        }
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/InputCheckBox.tsx